/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Who_4_TInputs */

const en_cp_who_4_t = /** @type {(inputs: Cp_Who_4_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus Leads & mentors`)
};

const id_cp_who_4_t = /** @type {(inputs: Cp_Who_4_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus Lead & mentor`)
};

/**
* | output |
* | --- |
* | "Campus Leads & mentors" |
*
* @param {Cp_Who_4_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_who_4_t = /** @type {((inputs?: Cp_Who_4_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Who_4_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_who_4_t(inputs)
	return en_cp_who_4_t(inputs)
});